import isEmpty from 'lodash/isEmpty'
import React from 'react'
import PropTypes from 'prop-types'
import EmptySection from '../../../atoms/EmptySection'
import CardListSkeleton from '../components/CardListSkeleton'

const ClientHighlightedList = ({
  clients,
  isLoading,
  itemClassName,
  emptyPlaceholderTitle,
  skeletonContainerClassName,
  cardComponent: CardComponent,

  // NEW: allows parent to style list wrapper items / empty state
  componentStyles
}) => {
  if (isLoading) {
    return (
      <CardListSkeleton
        cardListLength={4}
        itemClassName={itemClassName}
        containerClassName={skeletonContainerClassName}
      />
    )
  }

  if (!isLoading && isEmpty(clients)) {
    return (
      <EmptySection
        title={emptyPlaceholderTitle}
        description=''
        titleStyles={{
          fontSize: '1rem !important',

          // NEW: lets parent override empty section title styles
          ...componentStyles?.emptyTitle
        }}
      />
    )
  }

  return clients.map((client) => (
    <div
      key={client.clientId}
      className={itemClassName}
      // NEW: styles each item wrapper around CardComponent
      style={componentStyles?.item}
    >
      <CardComponent {...client} />
    </div>
  ))
}

ClientHighlightedList.propTypes = {
  clients: PropTypes.array,
  isLoading: PropTypes.bool,
  itemClassName: PropTypes.string,
  cardComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  emptyPlaceholderTitle: PropTypes.string,
  skeletonContainerClassName: PropTypes.string,

  // NEW
  componentStyles: PropTypes.shape({
    item: PropTypes.object,
    emptyTitle: PropTypes.object
  })
}

ClientHighlightedList.defaultProps = {
  clients: [],
  isLoading: false,
  emptyPlaceholderTitle: 'No clients found',

  // NEW
  componentStyles: undefined
}

export default ClientHighlightedList
